import { SourceImageSizeSpecType } from './source_image_size_spec_type';
import { getBreakpointSpecifiedValue } from './breakpoint_utils';

const getSourceImageWidth = (breakpoints, breakpointFlags, sourceImageSizeSpec) => {
  return getBreakpointSpecifiedValue(breakpoints, breakpointFlags, sourceImageSizeSpec.widths);
};

const getSourceImageAspectRatio = (breakpoints, breakpointFlags, sourceImageSizeSpec) => {
  return getBreakpointSpecifiedValue(breakpoints, breakpointFlags, sourceImageSizeSpec.aspectRatios);
};

export const getImageKitSpecsForSourceImageSizeSpec = (
  breakpoints, breakpointFlags, sourceImageSizeSpec, isVideo = false
) => {
  const width = getSourceImageWidth(breakpoints, breakpointFlags, sourceImageSizeSpec);
  const result = {
    width: width
  };
  if (!isVideo) result.progressive = true;
  // Add aspectRatio and focus parameters in some cases.
  if (sourceImageSizeSpec.type === SourceImageSizeSpecType.FIXED_ASPECT_RATIO) {
    result.aspectRatio = sourceImageSizeSpec.aspectRatio;
    if (!isVideo) result.focus = 'auto';
  } else if (sourceImageSizeSpec.type === SourceImageSizeSpecType.VARIABLE_ASPECT_RATIO) {
    result.aspectRatio = getSourceImageAspectRatio(breakpoints, breakpointFlags, sourceImageSizeSpec);
    if (!isVideo) result.focus = 'auto';
  }
  return result;
};
